// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","453":"64aababc","732":"e4596b42","977":"8dcf2e85"}[chunkId] + ".chunk.js";
};